import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { SearchComponent } from '../component/search/search.component';
import { CommunityComponent } from '../component/community/community.component';
import { SettingsComponent } from '../component/settings/settings.component';
import { AccountComponent } from '../component/account/account.component';
import { FloorplanComponent } from '../component/floorplan/floorplan.component';
import { FavoritesComponent } from '../component/favorites/favorites.component';
import { LoginComponent } from '../component/login/login.component';
import { DashboardComponent } from '../component/dashboard/dashboard.component';
import { AuthGuard } from '../service/auth.guard';

const appRoutes: Routes = [
	// { path: 'search', component: SearchComponent },
	{ path: 'search/:searchstr', component: SearchComponent },
	{ path: 'favorites', component: FavoritesComponent },
	{ path: 'settings', component: SettingsComponent },
	{ path: 'login', component: LoginComponent },
	{ path: 'dashboard', component: DashboardComponent, canActivate: [AuthGuard] },
	{ path: 'account', component: AccountComponent, canActivate: [AuthGuard] },
	{ path: 'community/:id', component: CommunityComponent },
	{ path: 'floorplan/:community/:planindex', component: FloorplanComponent },
	{
		path: '**',
		redirectTo: '/search/',
		pathMatch: 'full'
	}
];

@NgModule({
	imports: [
		RouterModule.forRoot(
			appRoutes
		)
	],
	exports: [
		RouterModule
	],
	declarations: []
})
export class RoutingModule { }
